"use client";

import {
  DetailedHTMLProps,
  HTMLAttributes,
  useCallback,
  useEffect,
} from "react";
import { cn } from "../lib/utils";
import Script from "next/script";

type Props = {
  formId: string;
  redirectUrl: string;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export default function HubspotForm({ formId, redirectUrl, ...props }: Props) {
  const id = `form-${formId}`;

  const loadForm = useCallback(() => {
    (window as any).hbspt.forms.create({
      region: "na1",
      portalId: "2266207",
      formId: formId,
      target: `#${id}`,
      redirectUrl: redirectUrl,
    });
  }, [id, formId, redirectUrl]);

  useEffect(() => {
    if ((window as any).hbspt) {
      loadForm();
    }
  }, [loadForm]);

  return (
    <>
      <Script
        id="hs-form-loader"
        type="text/javascript"
        src="//js.hsforms.net/forms/embed/v2.js"
        onLoad={() => {
          loadForm();
        }}
      />
      <div
        {...props}
        id={`form-${formId}`}
        className={cn("min-h-[400px]", props.className)}
      >
        <div className="grid animate-pulse items-center gap-10">
          <div className="grid md:grid-cols-2 gap-10">
            <div className="grid gap-3">
              <div className="bg-gray-300 w-[50%] h-4 rounded-sm" />
              <div className="bg-gray-300 h-8 rounded-sm" />
            </div>
            <div className="grid gap-3">
              <div className="bg-gray-300 w-[50%] h-4 rounded-sm" />
              <div className="bg-gray-300 h-8 rounded-sm" />
            </div>
          </div>
          <div className="grid gap-10">
            <div className="grid gap-3">
              <div className="bg-gray-300 w-[50%] h-4 rounded-sm" />
              <div className="bg-gray-300 h-8 rounded-sm" />
            </div>
            <div className="grid gap-3">
              <div className="bg-gray-300 w-[50%] h-4 rounded-sm" />
              <div className="bg-gray-300 h-8 rounded-sm" />
            </div>
          </div>
          <div>
            <div className="w-36 bg-gray-300 h-8 rounded-sm" />
          </div>
        </div>
      </div>
    </>
  );
}
